import { RestClient } from '@libs/rest-client';
import type { OperationControlRaw } from '../models';
import { OperationControl } from '../models';

async function fetchOperationControl() {
  return OperationControl.fromRaw(await RestClient.fa.get<OperationControlRaw>('/operation-control'));
}

export { fetchOperationControl };
